export default {
    base: process.env.NODE_ENV === 'production' ? '' : '',
    timeBeforeFade:3000,
    timeBeforeControlsFade:1000,
    width:1920,
    height:1038,
}
